/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiAppFromJSON(json) {
    return StreemApiAppFromJSONTyped(json, false);
}
export function StreemApiAppFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'sid': !exists(json, 'sid') ? undefined : json['sid'],
        'companySid': !exists(json, 'company_sid') ? undefined : json['company_sid'],
        'platform': !exists(json, 'platform') ? undefined : json['platform'],
        'platformAppId': !exists(json, 'platform_app_id') ? undefined : json['platform_app_id'],
        'allowMultiCompanyLogin': !exists(json, 'allow_multi_company_login') ? undefined : json['allow_multi_company_login'],
    };
}
export function StreemApiAppToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sid': value.sid,
        'company_sid': value.companySid,
        'platform': value.platform,
        'platform_app_id': value.platformAppId,
        'allow_multi_company_login': value.allowMultiCompanyLogin,
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiAppPlatform;
(function (StreemApiAppPlatform) {
    StreemApiAppPlatform["ANDROID"] = "APP_PLATFORM_ANDROID";
    StreemApiAppPlatform["INVALID"] = "APP_PLATFORM_INVALID";
    StreemApiAppPlatform["IOS"] = "APP_PLATFORM_IOS";
    StreemApiAppPlatform["WEB"] = "APP_PLATFORM_WEB";
})(StreemApiAppPlatform || (StreemApiAppPlatform = {}));
//# sourceMappingURL=StreemApiApp.js.map